// extracted by mini-css-extract-plugin
export var alignStart = "OneThirdSummaryDisplay-module--alignStart--c0399";
export var contained = "OneThirdSummaryDisplay-module--contained--3ce86";
export var container = "OneThirdSummaryDisplay-module--container--55e82";
export var equals = "OneThirdSummaryDisplay-module--equals--b19e5";
export var largeGap = "OneThirdSummaryDisplay-module--largeGap--e3cf0";
export var quarters = "OneThirdSummaryDisplay-module--quarters--b7360";
export var spaceAround = "OneThirdSummaryDisplay-module--spaceAround--566b1";
export var summaries = "OneThirdSummaryDisplay-module--summaries--4b603";
export var tallPadding = "OneThirdSummaryDisplay-module--tallPadding--a5fdb";